import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PalmtreeIcon, WineIcon, HomeIcon, PartyPopperIcon } from 'lucide-react';
const cases = [{
  icon: PalmtreeIcon,
  title: 'Group holidays',
  description: 'Flights, Airbnb, dinners out — one shared pot covers it all. No more "who paid for what?"',
  color: 'bg-blue-50',
  iconBg: 'bg-blue-100',
  iconColor: 'text-blue-600'
}, {
  icon: WineIcon,
  title: 'Nights out',
  description: 'Four rounds in and nobody knows who owes what. Log it in KittyPot. Sorted.',
  color: 'bg-purple-50',
  iconBg: 'bg-purple-100',
  iconColor: 'text-purple-600'
}, {
  icon: HomeIcon,
  title: 'Living together',
  description: 'Rent, bills, the weekly shop — manage it all in one place. No awkward texts.',
  color: 'bg-green-50',
  iconBg: 'bg-green-100',
  iconColor: 'text-green-600'
}, {
  icon: PartyPopperIcon,
  title: 'Birthdays & gifts',
  description: '"Everyone chip in £20 for Sarah." One pot, one link, done.',
  color: 'bg-orange-50',
  iconBg: 'bg-orange-100',
  iconColor: 'text-orange-600'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45
    }
  }
};
export function UseCases() {
  return <section id="use-cases" className="py-24 lg:py-32 bg-white" data-id="element-277">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-278">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-279">
          <p className="text-sm font-semibold text-kitty-yellow-600 uppercase tracking-widest mb-3" data-id="element-280">
            Made for real life
          </p>
          <h2 className="text-3xl md:text-4xl font-extrabold text-kitty-dark tracking-tight mb-3" data-id="element-281">
            Every group moment, covered
          </h2>
          <p className="text-base text-gray-500 max-w-md mx-auto" data-id="element-282">
            Real scenarios you'll recognise. One app handles them all.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-283">
          {cases.map((useCase, index) => <motion.div key={useCase.title} variants={itemVariants} className={`${useCase.color} rounded-2xl p-8 border border-transparent hover:border-gray-200 hover:-translate-y-1 transition-all duration-300 shadow-sm hover:shadow-md ${index === 0 ? 'col-span-1 sm:col-span-2 lg:col-span-1 border-l-4 border-l-kitty-yellow' : ''}`} data-id="element-284">
              <div className={`${useCase.iconBg} ${index === 0 ? 'w-16 h-16' : 'w-14 h-14'} rounded-xl flex items-center justify-center mb-6`} data-id="element-285">
                <useCase.icon className={`${index === 0 ? 'w-8 h-8' : 'w-7 h-7'} ${useCase.iconColor}`} data-id="element-286" />
              </div>
              <h3 className={`${index === 0 ? 'text-2xl' : 'text-xl'} font-bold text-kitty-dark mb-2`} data-id="element-287">
                {useCase.title}
              </h3>
              <p className={`text-gray-600 leading-relaxed ${index === 0 ? 'text-base' : 'text-sm'}`} data-id="element-288">
                {useCase.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}